import { useRouteMatch } from 'react-router';

import { fullscreenImageRoutes } from '../constants';

/**
 * Determine whether a fullscreen route is currently visible
 *
 * @returns boolean representing whether fullscreen is open
 */
export const useIsFullscreenImageOpen = () =>
  !!useRouteMatch(fullscreenImageRoutes);
